export function useHtmlToString(text: string) {
  const decodedText = new DOMParser().parseFromString(text, 'text/html');
  return decodedText.documentElement.textContent;
}
